import { Card, Grid } from '@mui/material';
import { VersionsCard } from '../../modules/Versions/components/VersionsCard';
import useStyles from '../../hooks/useStyles';
import styles from '../../layouts/pages/style';
import { Versions } from '../../modules/Versions';

export default function Breakdown(props) {
  const {
    more, editions, setRefreshOrgEdBreakdown, packageList,
  } = props;
  const classes = useStyles(styles)();

  return (
    <Grid container style={{ justifyContent: 'space-between' }} spacing={2}>
      <Grid item xs={12} md={7}>
        <VersionsCard packageList={packageList?.packages} />
      </Grid>

      <Grid item xs={12} md={5}>
        <Card className={classes.graphStyle}>
          <Versions
            orgEditionBreakdown
            editions={editions}
            more={more}
            setRefreshOrgEdBreakdown={setRefreshOrgEdBreakdown}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
